import { Button } from '@/components/atoms';
import type { ZoomLevel } from '@/hooks/useZoomPan';

export interface ZoomControlsProps {
  currentZoom: ZoomLevel;
  onZoomChange: (level: ZoomLevel, mousePosition?: { clientX: number; clientY: number }) => void;
  className?: string;
}

export function ZoomControls({ currentZoom, onZoomChange, className }: ZoomControlsProps) {
  const zoomLevels: Array<{ level: ZoomLevel; label: string }> = [
    { level: 'fit', label: 'Fit' },
    { level: 50, label: '50%' },
    { level: 100, label: '100%' },
    { level: 200, label: '200%' },
  ];

  const handleZoomClick = (level: ZoomLevel) => (event: React.MouseEvent<HTMLButtonElement>) => {
    onZoomChange(level, { clientX: event.clientX, clientY: event.clientY });
  };

  return (
    <div className={`flex gap-2 ${className || ''}`}>
      {zoomLevels.map(({ level, label }) => (
        <Button
          key={level}
          variant={currentZoom === level ? 'primary' : 'secondary'}
          size="md"
          onClick={handleZoomClick(level)}
        >
          {label}
        </Button>
      ))}
    </div>
  );
}
